import store from '@/store/index.js';
export default {
  props: {
    size: {
      type: Number,
      default: 10
    },
    config: {
      type: Object,
      default: function () {
        return {
        };
      }
    },
    limit: {
      type: Number,
      default: 100
    },
    title: {
      type: String,
      default: '上传照片'
    },
    image: {
      type: Array,
      default: function () {
        return [];
      }
    },
    bizType: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      imageLoading: false,
      imageUrl: '',
      imageError: '',
      hideUp: false,
      action: '/api/v1.0/chanquan/fast/uploadFile',
      dialogImageUrl: '',
      imageList: [],
      dialogVisible: false,
      uploadData: {},
      headers: {}
    };
  },

  created() {
    const token = store.getters.userInfo.accessToken;
    const tenantObj = store.getters.getTenantParams; // 租户id,跟区域相关
    if(tenantObj) {
      this.headers['TENANT-ID'] = tenantObj.tId;
    }
    if (token) {
      this.headers['Authorization'] = token;
    }
    this.uploadData.bizType = this.bizType;
    if (this.image.length >= this.limit) {
      this.hideUp = true;
    }
  },

  watch: {
    image(){
      if (this.image.length >= this.limit) {
        this.hideUp = true;
      }
    }
  },

  methods: {
    imageBeforeUpload(file) {
      this.imageError = '';
      const arr = ['png', 'jpg', 'jpeg'];
      if (!arr.find(item => file.type.indexOf(item) !== -1)) {
        this.imageError = '图片只能是 png，jpg，jpeg 格式!';
        return false;
      }
      if (file.size / 1024 / 1024 > this.size) {
        this.imageError = '图片大小不能超过' + this.size + 'M';
        return false;
      }
      const isSize = new Promise((resolve, reject) => {
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          const imgWidth = img.width;
          const imgHight = img.height;
          if (!this.config.width || !this.config.height) {
            this.uploadData.width = Math.floor(imgWidth);
            this.uploadData.height = Math.floor(imgHight);
            return resolve();
          }
          this.uploadData.width = Math.floor(this.config.width);
          this.uploadData.height = Math.floor(this.config.height);
          let valid = imgWidth === this.config.width && imgHight === this.config.height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return true;
      }, () => {
        this.imageError = '请上传正确的图片尺寸';
        return Promise.reject(false);
      });
      return isSize;
    },

    changeImage(file, fileList) {
      this.hideUp = fileList.length >= this.limit;
    },

    previewPhotoItem(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    removePhotoItem(file, fileList) {
      const list = fileList.map(item => {
        return {
          ossImgUrl: item.ossImgUrl ? item.ossImgUrl : item.response.data.allPath,
          sourceImgUrl: item.sourceImgUrl ? item.sourceImgUrl : item.response.data.fullPath
        };
      });
      this.hideUp = list.length >= this.limit;
      this.$emit('upload', list);
      this.$emit('fileList', fileList);
      console.log(fileList, 1);
    },

    handleExceed() {
      this.hideUp = true;
    },

    handleUpSuccess(response, file, fileList) {
      this.hideUp = fileList.length >= this.limit;
      console.log(fileList);
      const list = fileList.map(item => {
        return {
          ossImgUrl: item.ossImgUrl ? item.ossImgUrl : item.response.data.allPath,
          sourceImgUrl: item.sourceImgUrl ? item.sourceImgUrl : (item.response.data.fullPath)
        };
      });
      console.log(list);
      this.$emit('upload', list);
      this.$emit('fileList', fileList);
    },

    handleUpError(error) {
      this.imageError = error.reason;
    }
  }
};
